import { Component, OnInit } from '@angular/core';
import { LeadsService, LeadAdminDto } from './leads.service';
import { NotificationService } from '../../core/notification.service';
import { FornecedoresService } from '../fornecedores/fornecedores.service';

@Component({
  standalone: false,
  selector: 'app-leads-list',
  templateUrl: './leads-list.component.html',
  styleUrls: ['./leads-list.component.css']
})
export class LeadsListComponent implements OnInit {
  loading = false;
  loadingFornecedores = false;
  page = 1;
  pageSize = 20;
  total = 0;

  fornecedorId = '';
  clienteEmail = '';
  emailSent?: string;
  isRead?: string;
  dataInicio = '';
  dataFim = '';

  items: LeadAdminDto[] = [];
  fornecedores: any[] = [];
  private fornecedoresMap = new Map<string, string>();
  
  // Para controlar filtros ativos
  get activeFiltersCount(): number {
    let count = 0;
    if (this.fornecedorId) count++;
    if (this.clienteEmail) count++;
    if (this.emailSent !== undefined) count++;
    if (this.isRead !== undefined) count++;
    if (this.dataInicio) count++;
    if (this.dataFim) count++;
    return count;
  }

  constructor(
    private svc: LeadsService,
    private notify: NotificationService,
    private fornecedorSvc: FornecedoresService
  ) {}

  ngOnInit(): void {
    this.loadFornecedores();
    this.load();
  }

  loadFornecedores(): void {
    this.loadingFornecedores = true;
    // Carregar apenas os 100 primeiros fornecedores para dropdown
    this.fornecedorSvc.list(1, 100).subscribe({
      next: (res: any) => {
        this.fornecedores = res.items || res.data || [];
        this.fornecedoresMap = new Map(this.fornecedores.map((f: any) => [f.id, f.nome]));
        this.loadingFornecedores = false;
      },
      error: (err: any) => {
        console.error('[LeadsList] erro ao carregar fornecedores', err);
        this.fornecedores = [];
        this.loadingFornecedores = false;
      }
    });
  }

  load(): void {
    this.loading = true;
    this.svc.list({
      page: this.page,
      pageSize: this.pageSize,
      fornecedorId: this.fornecedorId || undefined,
      clienteEmail: this.clienteEmail || undefined,
      emailSent: this.emailSent === undefined ? undefined : this.emailSent === 'true',
      isRead: this.isRead === undefined ? undefined : this.isRead === 'true',
      dataInicio: this.dataInicio || undefined,
      dataFim: this.dataFim || undefined,
    }).subscribe({
      next: (res: any) => {
        this.items = (res.data || []).map((lead: LeadAdminDto) => {
          if (lead.fornecedor?.id && !lead.fornecedor.nome && this.fornecedoresMap.has(lead.fornecedor.id)) {
            return { ...lead, fornecedor: { ...lead.fornecedor, nome: this.fornecedoresMap.get(lead.fornecedor.id)! } };
          }
          return lead;
        });
        this.total = res.meta?.total || this.items.length;
        this.loading = false;
      },
      error: (err: any) => {
        console.error('[LeadsList] erro ao carregar leads', err);
        this.notify.showError('Erro ao carregar leads');
        this.loading = false;
      }
    });
  }

  resetFilters(): void {
    this.fornecedorId = '';
    this.clienteEmail = '';
    this.emailSent = undefined;
    this.isRead = undefined;
    this.dataInicio = '';
    this.dataFim = '';
    this.page = 1;
    this.load();
  }

  resendEmail(lead: LeadAdminDto): void {
    this.svc.resend(lead.id).subscribe({
      next: () => {
        this.notify.showSuccess('Email reenviado com sucesso');
        this.load();
      },
      error: (err) => {
        console.error('[LeadsList] erro ao reenviar email', err);
        this.notify.showError('Erro ao reenviar email');
      }
    });
  }

  openWhatsApp(lead: LeadAdminDto): void {
    const digits = (lead.clientePhone || '').replace(/\D/g, '');
    const phone = digits.startsWith('55') ? digits : '55' + digits;
    const name = lead.clienteName || 'cliente';
    const message =
      `Olá, ${name}.\n` +
      `aqui é a equipe do guia noivas Piracicaba, ficamos muito felizes que tenha usado nosso serviço, ` +
      `gostaríamos de saber se recebeu o retorno do(s) fornecedor(es)? ` +
      `Também gostaríamos de saber se podemos ajudar com algum outro assunto? `;
    const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  }

  onPageChange(p: number) {
    this.page = p;
    this.load();
  }

  displayEnd(): number {
    const end = this.page * this.pageSize;
    return end > this.total ? this.total : end;
  }
}
